const endpoints = {
  "globalStatsSummary": "https://engine.covid19caribtracker.com/api/summary_statistics/01a5698e-186d-4487-aece-1c91b0e48959",
  "statsByCountry": "https://engine.covid19caribtracker.com/api/node/case_statistic",
  "newsArticles": "https://engine.covid19caribtracker.com/api/articles"
};

export const apiEnginePublicBase = "https://engine.covid19caribtracker.com";

export default endpoints;